<template lang="html">

</template>

<script>
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

// app路由
import Index from './Index'
import Search from './Search'
import Deliver from './Deliver'
import Cart from './cart'
import myaccount from './myaccount'
import more from './more'

const appRoutes = [
  { path: "/",component: Index},
  { path: "/search",component: Search},
  { path: "/deliver",component: Deliver},
  { path: "/cart",component: Cart},
  { path: "/myaccount",component: myaccount},
  { path: "/more",component: more}
]
const router = new VueRouter({
  routes: appRoutes
})

export default {
  router: router
}
</script>



// WEBPACK FOOTER //
// appRouter.vue?10ef018e